module.exports = __webpack_public_path__ + "img/helvetica+georgia.155b4945.png";